import styles from '/builds/servicebund/servicebund-websites/.build/releases/1/DistributionPackages/Servicebund.RodeoSteakDe/Resources/Private/Fusion/Presentation/Leaf/Map/Map.css';
import script from '/builds/servicebund/servicebund-websites/.build/releases/1/DistributionPackages/Servicebund.RodeoSteakDe/Resources/Private/Fusion/Presentation/Leaf/Map/Map.ts';

export const prototypeName = 'Servicebund.RodeoSteakDe:Component.Map';
export {styles};
export {script};